import React, { useMemo, useState } from "react";
import "../styles.scss";
import UsersAppStatus from "components/Dashboards/Components/UsersAppStatus";
import SubTitle from "components/SubTitle";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { useTranslation } from "react-i18next";
import DateSelect from "components/bootstrap/DateSelect/DateSelect";
import ReportsSent from "components/Dashboards/AdministrativeDashboard/ReportsSent";
import ReportsCompletedPerControlCenter from "components/Dashboards/AdministrativeDashboard/ReportsCompletedPerControlCenter";
import ReportsCompletedPerRole from "components/Dashboards/AdministrativeDashboard/ReportsCompletedPerRole";
import { useGetManagerDashboardQuery } from "features/api/dashboards/dashboardsApiSlice";
import { Spinner } from "react-bootstrap";
import { datePeriodOptions, getTitle } from "../utils";
import { administrativeDashboardTypes } from "./types";

const AdministrativeDashboard = () => {
  const { t } = useTranslation();
  const [selectedPeriod, setSelectedPeriod] = useState("monthly");
  const periodNumber = useMemo(() => {
    switch (selectedPeriod) {
      case "monthly":
        return 30;
      case "weekly":
        return 7;
      case "perYear":
        return 365;
      default:
        return 0;
    }
  }, [selectedPeriod]);

  const controllerName = useGetUserData(LocalStorageKey.UserName);
  const {
    data,
    isLoading,
  }: {
    data: administrativeDashboardTypes;
    isLoading: boolean;
    isFetching: boolean;
  } = useGetManagerDashboardQuery({
    period: periodNumber,
  });

  return isLoading ? (
    <div className="loader-container">
      <Spinner animation="border" variant="primary" />
    </div>
  ) : (
    <div className="administrative-dashboard-container">
      <div className="right-screen">
        <div className="title-container">
          <div className="right-title">
            <SubTitle className="title">{getTitle(controllerName)}</SubTitle>
            <p className="sub-title">
              {t("monthlyTargetPackaging")}
              <span className="numerator">{` ${data.policeStatistic.currentSendToPolice}`}</span>
              {`/${1500}`}
            </p>
            <p className="sub-title" style={{ marginRight: "20px" }}>
              {t("deshboardLastCall")}
              {data.lastCall}
            </p>
          </div>
          <div className="left-title">
            <DateSelect
              className="period-select"
              value={selectedPeriod}
              onChange={(e) => {
                setSelectedPeriod(e.target.value);
              }}
            >
              {datePeriodOptions}
            </DateSelect>
          </div>
        </div>
        <div className="charts-container">
          <ReportsSent data={data.policeStatistic} period={selectedPeriod} />
          <ReportsCompletedPerControlCenter
            data={data.reportCompletedByControlCenterDetails}
            period={selectedPeriod}
          />
        </div>
        <ReportsCompletedPerRole
          data={data.reportCompletedByRoles}
          total={data.reportCompletedByRolesTotalAmount}
          period={selectedPeriod}
        />
      </div>

      <div className="left-screen">
        <UsersAppStatus data={data.volunteerRegistrationData} />
      </div>
    </div>
  );
};
export default AdministrativeDashboard;
